import { render, staticRenderFns } from "./TokenList.vue?vue&type=template&id=ffa2d30c"
import script from "./TokenList.vue?vue&type=script&lang=js"
export * from "./TokenList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports